import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { AppRouter } from './AppRouter';
render(<AppRouter data-id="element-18261" data-mp="1wabcavth7ajd" />, document.getElementById('root'));